import { Component, OnInit, Input } from '@angular/core';
import { IStoreMenuCategory, IStoreMenuItem } from '../../services/store.service';
import { ModalController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
//import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-item-two-for-ones',
    templateUrl: './item-two-for-ones.component.html',
    styleUrls: ['./item-two-for-ones.component.scss'],
    standalone: false
})
export class ItemTwoForOnesComponent implements OnInit {
  @Input() selectedCategory: IStoreMenuCategory;
  @Input() selectedItem: IStoreMenuItem;

  items: IStoreMenuItem[] = [];

  constructor(
    private modalCtrl: ModalController,
    //public translateService: TranslateService
    public translationService: TranslationService
    ) {
  }

  ngOnInit() {
    if(this.selectedItem.parentItemId){
      let parentItem = this.selectedCategory.storeMenuCategoryItems.find(t => t.itemId == this.selectedItem.parentItemId);
      this.items.push(parentItem.item);
      for(let subItem of parentItem.subItems){
        this.items.push(subItem);
      }
    } else {
      let categoryItem = this.selectedCategory.storeMenuCategoryItems.find(t => t.itemId == this.selectedItem.id);
      if(categoryItem.subItems.length > 0){
        this.items.push(categoryItem.item);
        for(let subItem of categoryItem.subItems){
          this.items.push(subItem);
        }
      } else {
        for(let item of this.selectedCategory.storeMenuCategoryItems){
          this.items.push(item.item);
        }
      }
    }
  }

  onItemClick(item: IStoreMenuItem){
    this.modalCtrl.dismiss({
      item: item
    });
  }

  cancel() {
    this.modalCtrl.dismiss();
  }
}